<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.username }}
        </p>
        <span class="user-status">{{ $t('common.' + userData.role.toLowerCase()) }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'drs-products'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="ShoppingBagIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.products') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'drs-customers' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.customers') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'drs-budgets' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="FileTextIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.budgets') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'drs-invoices' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="DollarSignIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.invoices') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      :to="{ name: 'drs-users' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UsersIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.users') }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('common.logout') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import auth from '@/models/auth'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
  methods: {
    async logout() {
      await auth.logout()
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })

      //
      localStorage.setItem('expiredToken', false)
    },
  },
}
</script>
